var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._g({staticClass:"sign-up-link",attrs:{"href":""}},_vm.$listeners),[_c('span',{staticClass:"sign-up-link__content"},[_vm._v("Sign up")])])}
var staticRenderFns = []

export { render, staticRenderFns }